import styles from '@/app/cv/components/sections/home/style.module.css';
import { cn } from '@/app/utils/cn';

interface ButterflyProps {
  src: string;
  className?: string;
  variant?: 'banner' | 'lineup';
}

export const Butterfly = ({
  src,
  className,
  variant = 'banner',
}: ButterflyProps) => {
  return (
    <div className={cn(styles[`decorate-${variant}`], className)}>
      <div
        className={cn(styles[`butterfly-${variant}`])}
        style={{ backgroundImage: `url(${src})` }}
        aria-hidden
      />
    </div>
  );
};
